document.addEventListener("DOMContentLoaded", function () {
  const overlay = createOverlay();
  document.body.appendChild(overlay);

  const imgEl = overlay.querySelector(".lightbox-img");
  const spinner = overlay.querySelector(".lightbox-spinner");
  const errorMsg = overlay.querySelector(".lightbox-error");
  const countEl = overlay.querySelector(".lightbox-count");
  const prevBtn = overlay.querySelector(".lightbox-prev");
  const nextBtn = overlay.querySelector(".lightbox-next");

  document.querySelectorAll(".lightbox").forEach((group) => {
    const images = group.querySelectorAll("[data-lightbox-image]");
    const imageArray = Array.from(images).map((img) => img.dataset.lightboxImage);

    images.forEach((img, index) => {
      img.addEventListener("click", (e) => {
        e.preventDefault();
        openLightbox(imageArray, index);
      });
    });
  });

  function createOverlay() {
    const el = document.createElement("div");
    el.className = "lightbox-overlay";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", "Galerie obrázků");
    el.innerHTML = `
      <button class="lightbox-close" aria-label="Zavřít galerii">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
      </button>
      <button class="lightbox-prev" aria-label="Předchozí obrázek">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
      </button>
      <button class="lightbox-next" aria-label="Další obrázek">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </button>
      <div class="lightbox-content">
        <div class="lightbox-img-wrapper">
          <div class="lightbox-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
          </div>
          <div class="lightbox-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
            <span>Obrázek se nepodařilo načíst</span>
          </div>
          <img class="lightbox-img" src="" alt="Obrázek galerie" />
        </div>
        <div class="lightbox-count" aria-live="polite"></div>
      </div>
    `;
    el.querySelector(".lightbox-close").onclick = closeLightbox;
    el.querySelector(".lightbox-prev").onclick = () => changeImage(-1);
    el.querySelector(".lightbox-next").onclick = () => changeImage(1);
    el.onclick = (e) => { if (e.target === el) closeLightbox(); };

    // Touch/swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    el.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    el.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].screenX - touchStartX;
      const dy = e.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
        changeImage(dx > 0 ? -1 : 1);
      }
    }, { passive: true });

    return el;
  }

  let currentIndex = 0;
  let currentImages = [];
  let triggerElement = null;

  function openLightbox(images, index) {
    currentImages = images;
    currentIndex = index;
    triggerElement = document.activeElement;

    // Show/hide nav buttons for single image
    prevBtn.style.display = images.length > 1 ? "" : "none";
    nextBtn.style.display = images.length > 1 ? "" : "none";
    countEl.style.display = images.length > 1 ? "" : "none";

    updateImage();
    overlay.classList.add("active");
    requestAnimationFrame(() => overlay.classList.add("visible"));
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", keyControls);

    const closeBtn = overlay.querySelector(".lightbox-close");
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    overlay.classList.remove("visible");
    overlay.addEventListener("transitionend", function handler() {
      overlay.removeEventListener("transitionend", handler);
      overlay.classList.remove("active");
    });
    document.body.style.overflow = "";
    document.removeEventListener("keydown", keyControls);

    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
  }

  function changeImage(offset) {
    currentIndex = (currentIndex + offset + currentImages.length) % currentImages.length;
    updateImage();
  }

  function updateImage() {
    const newSrc = currentImages[currentIndex];

    // Show spinner, hide error and image
    spinner.classList.add("active");
    errorMsg.classList.remove("active");
    imgEl.classList.remove("loaded");

    const tempImg = new Image();
    tempImg.onload = () => {
      imgEl.src = newSrc;
      imgEl.classList.add("loaded");
      spinner.classList.remove("active");
    };
    tempImg.onerror = () => {
      spinner.classList.remove("active");
      errorMsg.classList.add("active");
      imgEl.classList.remove("loaded");
    };
    tempImg.src = newSrc;

    imgEl.alt = "Obrázek " + (currentIndex + 1) + " z " + currentImages.length;
    countEl.textContent = (currentIndex + 1) + " / " + currentImages.length;
  }

  function keyControls(e) {
    if (e.key === "ArrowRight") changeImage(1);
    if (e.key === "ArrowLeft") changeImage(-1);
    if (e.key === "Escape") closeLightbox();

    if (e.key === "Tab") {
      const focusableEls = overlay.querySelectorAll("button:not([style*='display: none'])");
      if (!focusableEls.length) return;
      const first = focusableEls[0];
      const last = focusableEls[focusableEls.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }
});
